module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0090.jpg?v=f8aac5c8";